import { Search } from 'lucide-react';
import { forwardRef, type ComponentPropsWithoutRef } from 'react';

import { Input, cn } from '@shigo-ui/ui';

export interface DashboardTableSearchInputProps extends ComponentPropsWithoutRef<typeof Input> {
  containerClassName?: string | undefined;
}

export const DashboardTableSearchInput = forwardRef<
  HTMLInputElement,
  DashboardTableSearchInputProps
>(
  (
    {
      containerClassName,
      className,
      type = 'search',
      'aria-label': ariaLabel = 'Search',
      ...props
    },
    ref,
  ) => (
    <div className={cn('relative w-full max-w-full sm:w-[280px]', containerClassName)}>
      <Search
        className="text-muted-foreground pointer-events-none absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2"
        aria-hidden="true"
      />
      <Input
        ref={ref}
        aria-label={ariaLabel}
        type={type}
        className={cn('bg-card h-9 pl-9', className)}
        placeholder="Search"
        {...props}
      />
    </div>
  ),
);
DashboardTableSearchInput.displayName = 'DashboardTableSearchInput';
